// components/ExerciseTimeSelect.js
import { exerciseTimeOptions } from "data/dropdowndData/adviseMeOptions";
import React from "react";
import { useTranslation } from "react-i18next";

const ExerciseTimeSelect = ({
  value,
  label,
  isAdviceLoading = false,
  handleSelecChange,
}) => {
  const { t } = useTranslation();

  // const exerciseTimeOptions = [
  //   "0-15min",
  //   "15-30min",
  //   "30-45min",
  //   "45-60min",
  //   "60min+",
  // ];

  return (
    <div className="w-full">
      <span className="text-[#414651] text-[12px] font-semibold text-gray-700 uppercase block mb-1">
        {label}
      </span>
      <select
        className={`border p-2 rounded-md w-full h-10 text-sm outline-none bg-white ${
          isAdviceLoading ? "opacity-70 cursor-default" : ""
        }`}
        value={value || ""}
        onChange={(e) =>
          handleSelecChange("dailyExerciseTimePreference", e.target.value)
        }
        disabled={isAdviceLoading}
      >
        <option value="" disabled>
          {t("preferences.validation.onlyOne")}
        </option>
        {exerciseTimeOptions.map((option) => (
          <option key={option} value={option}>
            {t(
              `allPreferencesModule.options.dailyExerciseTimePreference.${option}`
            )}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ExerciseTimeSelect;